import { render, staticRenderFns } from "./ModifierListsCreate.vue?vue&type=template&id=8fc51708&"
import script from "./ModifierListsCreate.vue?vue&type=script&lang=js&"
export * from "./ModifierListsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports